import { useEffect, useState } from "react";
import { supabase } from "./supabaseClient";

export default function NubbiMadness() {
  const [currentRoundMatchups, setCurrentRoundMatchups] = useState([]);
  const [currentMatch, setCurrentMatch] = useState(0);
  const [round, setRound] = useState(1);
  const [nextRoundWinners, setNextRoundWinners] = useState([]);
  const [champion, setChampion] = useState(null);
  const [allParticipants, setAllParticipants] = useState([]);
  const [eliminatedIds, setEliminatedIds] = useState([]);

  useEffect(() => {
    async function loadBracket() {
      const { data: characters } = await supabase
        .from("characters")
        .select("id, name, image, creador_url, universo");

      if (!characters) return;

      const shuffled = characters
        .filter((char) => char.image)
        .sort(() => 0.5 - Math.random())
        .slice(0, 64)
        .map((char) => ({
          id: char.id,
          name: char.name || "Unknown",
          image: char.image,
          nubbid: char.id,
          creador: char.creador_url || "",
          universo: char.universo || "",
        }));

      const initial = [];
      for (let i = 0; i < 32; i++) {
        initial.push([shuffled[i], shuffled[63 - i]]);
      }

      setCurrentRoundMatchups(initial);
      setAllParticipants(shuffled);
    }

    loadBracket();
  }, []);

  function handleVote(winner) {
    const currentPair = currentRoundMatchups[currentMatch];
    const loser = currentPair.find((c) => c.id !== winner.id);

    const updatedWinners = [...nextRoundWinners, winner];
    setNextRoundWinners(updatedWinners);
    setEliminatedIds((prev) => [...prev, loser.id]);

    if (currentMatch + 1 < currentRoundMatchups.length) {
      setCurrentMatch(currentMatch + 1);
    } else {
      if (updatedWinners.length === 1) {
        setChampion(updatedWinners[0]);
        return;
      }

      const newMatchups = [];
      for (let i = 0; i < updatedWinners.length; i += 2) {
        newMatchups.push([updatedWinners[i], updatedWinners[i + 1]]);
      }

      setCurrentRoundMatchups(newMatchups);
      setNextRoundWinners([]);
      setCurrentMatch(0);
      setRound(round + 1);
    }
  }

  const roundText = {
    1: "🌀 ROUND OF 32 – Single elimination",
    2: "⚔️ SWEET 16 – Win or go home",
    3: "💥 ELITE 8 – Quarterfinals",
    4: "🔥 FINAL 4 – Semifinals",
    5: "👑 GRAND FINALE – The final duel",
  };

  if (champion) {
    return (
      <div style={{ textAlign: "center", padding: 40, color: "#fff", background: "#111" }}>
        <h1 style={{ fontSize: "2rem", textShadow: "0 0 10px #0ff" }}>🏆 NUBBI MADNESS CHAMPION 🏆</h1>
        <img src={champion.image} alt={champion.name} style={{ width: 250, borderRadius: 20, marginTop: 20 }} />
        <h2 style={{ fontSize: "1.5rem", marginTop: 10 }}>{champion.name}</h2>
        <p style={{ marginTop: 8 }}>Nubb-ID: <strong>{champion.nubbid}</strong></p>
        <p>
          Creator: <a href={`https://nubbiland.com/HQ.${champion.creador}`} style={{ color: "#0ff", textDecoration: "underline", cursor: "pointer" }} target="_blank" rel="noopener noreferrer">{champion.creador}</a>
        </p>
        <p>
          Universe: <a href={`https://nubbiland.com/universo/${champion.universo}`} style={{ color: "#0ff", textDecoration: "underline", cursor: "pointer" }} target="_blank" rel="noopener noreferrer">{champion.universo}</a>
        </p>
      </div>
    );
  }

  if (currentRoundMatchups.length === 0) {
    return <p style={{ textAlign: "center", marginTop: 40, color: "#fff" }}>Loading bracket...</p>;
  }

  const [left, right] = currentRoundMatchups[currentMatch];
  const advancing = allParticipants.filter(char => !eliminatedIds.includes(char.id));
  const eliminated = allParticipants.filter(char => eliminatedIds.includes(char.id));

  return (
    <div style={{ backgroundColor: "#000", color: "#0ff", minHeight: "100vh", padding: 20, fontFamily: "'Press Start 2P', cursive" }}>
      <h2 style={{
        fontSize: "1.6rem",
        textAlign: "center",
        marginBottom: 10,
        textShadow: "0 0 10px #00f7ff, 0 0 20px #00f7ff",
        fontFamily: "'Press Start 2P', cursive",
        letterSpacing: "1px"
      }}>🎮 NUBBI MADNESS 🎮</h2>

      <p style={{
        textAlign: "center",
        marginBottom: 30,
        fontSize: "1rem",
        textShadow: "0 0 5px #00f7ff",
        fontFamily: "'Press Start 2P', cursive",
      }}>{roundText[round]}</p>

      <div style={{ display: "flex", justifyContent: "center", gap: 40, marginBottom: 50 }}>
        <div onClick={() => handleVote(left)} style={{ cursor: "pointer", width: 200 }}>
          <img src={left.image} alt={left.name} style={{ width: "100%", borderRadius: 12 }} />
          <h3 style={{ textAlign: "center", marginTop: 10 }}>{left.name}</h3>
        </div>

        <div onClick={() => handleVote(right)} style={{ cursor: "pointer", width: 200 }}>
          <img src={right.image} alt={right.name} style={{ width: "100%", borderRadius: 12 }} />
          <h3 style={{ textAlign: "center", marginTop: 10 }}>{right.name}</h3>
        </div>
      </div>

      <div style={{ marginBottom: 40 }}>
        <h3 style={{ textAlign: "center", marginBottom: 20, textShadow: "0 0 5px #0f0" }}>✅ ADVANCING</h3>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(8, 1fr)", gap: 10 }}>
          {advancing.map((char) => (
            <div key={char.id}>
              <img src={char.image} alt={char.name} style={{ width: "100%", borderRadius: 8 }} />
            </div>
          ))}
        </div>
      </div>

      <div>
        <h3 style={{ textAlign: "center", marginBottom: 20, textShadow: "0 0 5px #f00" }}>❌ ELIMINATED</h3>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(8, 1fr)", gap: 10 }}>
          {eliminated.map((char) => (
            <div key={char.id} style={{
              filter: "grayscale(100%)",
              opacity: 0.3,
              transition: "all 0.3s ease",
            }}>
              <img src={char.image} alt={char.name} style={{ width: "100%", borderRadius: 8 }} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
